// Grid row shape of POST /asset-transactions/filter (view__asset_transactions).
import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

export const AssetTransactionRecordSchema = z
  .object({
    asset_transactions__id: z.string(),
    asset_transactions__name: z.string().nullish(),
    asset_transactions__transaction_date: z.string().nullish(),
    asset_transactions__transaction_date_fmt: z.string().nullish(),
    accounts__id: z.string(),
    accounts__name: z.string().nullish(),
    funds__id: z.string().nullish(),
    funds__name: z.string().nullish(),
    cfg_asset_transaction_types__id: z.number().nullish(),
    cfg_asset_transaction_types__label: z.string().nullish(),
    cfg_transaction_statuses__id: z.number().nullish(),
    cfg_transaction_statuses__label: z.string().nullish(),
    securities__id: z.string().nullish(),
    securities__name: z.string().nullish(),
    currencies__code: z.string().nullish(),
    asset_transactions__amount: z.number().nullish(),
    asset_transactions__amount_fmt: z.string().nullish(),
    // units / principal: acquired-else-disposed (a transaction has one side)
    asset_transactions__no: z.number().nullish(),
    asset_transactions__no_fmt: z.string().nullish(),
    asset_transactions__principal: z.number().nullish(),
    asset_transactions__principal_fmt: z.string().nullish(),
    asset_transactions__unit_value: z.number().nullish(),
    asset_transactions__unit_value_fmt: z.string().nullish(),
    tranches__id: z.string().nullish(),
    tranches__name: z.string().nullish(),
    tranches_created__id: z.string().nullish(),
    tranches_created__name: z.string().nullish(),
    asset_transactions__journal_count: z.number().nullish()
  })
  .strict()

export const AssetTransactionRecordFields = makeFieldKeys(AssetTransactionRecordSchema)

export type AssetTransactionRecord = z.infer<typeof AssetTransactionRecordSchema>

export function validateAssetTransactionRecord(data: unknown, isArray: true): AssetTransactionRecord[]
export function validateAssetTransactionRecord(data: unknown, isArray?: false): AssetTransactionRecord
export function validateAssetTransactionRecord(data: unknown, isArray?: boolean): AssetTransactionRecord | AssetTransactionRecord[]
export function validateAssetTransactionRecord(data: unknown, isArray = false): AssetTransactionRecord | AssetTransactionRecord[] {
  try {
    return validateWithZodSchema(AssetTransactionRecordSchema, data, 'asset transaction record', { isArray })
  } catch (error) {
    throw new Error(`Asset transaction record validation failed: ${error}`)
  }
}
